import { render, staticRenderFns } from "./GlossaryHeader.vue?vue&type=template&id=6807f788&scoped=true&"
import script from "./GlossaryHeader.vue?vue&type=script&lang=js&"
export * from "./GlossaryHeader.vue?vue&type=script&lang=js&"
import style0 from "./GlossaryHeader.vue?vue&type=style&index=0&id=6807f788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6807f788",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
